import { useState } from "react";

/** Imagem de conteúdo editorial com carregamento, proporção fixa e marca d'água quando não há foto. */
export const ContentImage = ({ src, alt, testId, className = "", ratio = "aspect-[16/9]" }) => {
  const [state, setState] = useState(src ? "loading" : "empty");

  if (state === "empty" || state === "error") {
    return (
      <div
        data-testid={`${testId}-placeholder`}
        className={`${ratio} grid w-full place-items-center overflow-hidden rounded-2xl bg-sand ${className}`}
      >
        <span className="er-label select-none text-[11px] tracking-[0.3em] text-sage-700/60">ERIMUS</span>
      </div>
    );
  }

  return (
    <div className={`${ratio} relative w-full overflow-hidden rounded-2xl bg-sand ${className}`}>
      {state === "loading" ? <div className="absolute inset-0 animate-pulse bg-sand" aria-hidden="true" /> : null}
      <img
        data-testid={testId}
        src={src}
        alt={alt || ""}
        loading="lazy"
        onLoad={() => setState("ready")}
        onError={() => setState("error")}
        className="h-full w-full object-cover"
      />
    </div>
  );
};

export default ContentImage;
